import { AsideMenuActionItem } from "./AsideMenuActionItem"
import { AsideMenuItemWithSub } from "../../../../layout/components/aside/AsideMenuItemWithSub"
import { IPageAction } from "../../../base/models"

export const AsideMenuActionGroup = ({ action, className }: {
    action: IPageAction,
    className?: string
}) => {
    const { actions } = action

    return <>
        <AsideMenuItemWithSub
            to=''
            className={className}
            title={action.name}
            fontIcon='bi-chat-left'
            materialIcon={action.icon}>

            {actions?.map(action => (
                <AsideMenuActionItem
                    key={action.actionId}
                    hasBullet={true}
                    className={'fs-8 py-1'}
                    action={action} />
            ))}

        </AsideMenuItemWithSub>
    </>
}